"use client";
import ContactForm, {
	formSubmitResult,
} from "../../../components/contact-form";
import { AnalyticEventNames } from "../../../utilities/env";
import { leadFormData } from "../../../utilities/lead-form-submission";
import { analytics } from "../../../utilities/segment";

function onSubmit(formData: leadFormData, zipCode: string): formSubmitResult {
	formData.Zip = zipCode;
	formData.MarketingMeta.OriginWebPageType = "dx-designcenter-contact-us";
	formData.MarketingMeta.OriginWebFormCategory = "dx-designcenter-contact-us";

	const userIdentify = {
		firstName: formData.FirstName,
		lastName: formData.LastName,
		email: formData.Email,
		phone: formData.PhoneNumber,
	};
	analytics?.identify(userIdentify);
	analytics?.track(AnalyticEventNames.genericContactFormSubmitted, {
		formId: "contact-us-form",
		comments: formData.LeadComments,
		writtenTextMessageConsent: formData.WrittenTextMessageConsent === "on",
		...userIdentify,
	});

	return { formData: formData, formStatusType: "success" };
}

export default function ContactFormClient({ zipCode }: { zipCode: string }) {
	return (
		<ContactForm
			onSubmit={(formData) => onSubmit(formData, zipCode)}
			zipCode={zipCode}
		/>
	);
}
